/**
 * API Services pour la gestion des sessions
 * RÉUTILISABILITÉ : 100% - TypeScript pur
 */

import { apiClient } from '@shared/infrastructure/http';
import { getAuthConfig } from '../../config/authConfig';
import type {
  ApiResponse,
  ListSessionsData,
  SessionsListResult,
  RevoqueSessionData,
  RevokeAllSessionsData,
} from '../../application/dto/dtos';

/**
 * Service sessions
 */
export const sessionApi = {
  /**
   * Lister toutes les sessions actives de l'utilisateur
   */
  async listSessions(data: ListSessionsData): Promise<ApiResponse<SessionsListResult>> {
    const config = getAuthConfig();
    const { idUtilisateur, actives, limite } = data;

    // Construire query params
    const params = new URLSearchParams();
    params.append('idUtilisateur', idUtilisateur);
    if (actives !== undefined) params.append('actives', String(actives));
    if (limite !== undefined) params.append('limite', String(limite));

    const url = `${config.endpoints.listSessions}?${params.toString()}`;
    return apiClient.get<SessionsListResult>(url);
  },

  /**
   * Révoquer une session spécifique
   */
  async revokeSession(data: RevoqueSessionData): Promise<ApiResponse<void>> {
    // Construire l'URL avec l'idSession dynamique
    const url = `/api/auth/sessions/${data.idSession}`;

    // Utiliser DELETE avec le body contenant idUtilisateur
    return apiClient.delete<void>(url, { idUtilisateur: data.idUtilisateur });
  },

  /**
   * Révoquer toutes les sessions (sauf l'actuelle si spécifié)
   */
  async revokeAllSessions(data: RevokeAllSessionsData): Promise<ApiResponse<void>> {
    const config = getAuthConfig();
    return apiClient.post<void>(config.endpoints.revokeAllSessions, data);
  },
};
